// projects/humanresources-personnel/src/assets/i18n/*/hr-per-contract.json
export class HrPerContractKey {
    private static readonly keyPrefix = 'hrPerContract';
    public static title = `${HrPerContractKey.keyPrefix}.title`;
    public static pageHeader = `${HrPerContractKey.keyPrefix}.pageHeader`;
    public static fee = `${HrPerContractKey.keyPrefix}.fee`;
    public static startDate = `${HrPerContractKey.keyPrefix}.startDate`;
    public static endDate = `${HrPerContractKey.keyPrefix}.endDate`;
    public static hrmTypeCode = `${HrPerContractKey.keyPrefix}.hrmTypeCode`;
    public static genCurrencyUuid = `${HrPerContractKey.keyPrefix}.genCurrencyUuid`;
    public static genCurrencyCode = `${HrPerContractKey.keyPrefix}.genCurrencyCode`;
    public static contractAnnulmentDate = `${HrPerContractKey.keyPrefix}.contractAnnulmentDate`;
    public static contractNumber = `${HrPerContractKey.keyPrefix}.contractNumber`;
    public static signedBy = `${HrPerContractKey.keyPrefix}.signedBy`;
    public static signedPeople = `${HrPerContractKey.keyPrefix}.signedPeople`;
    public static contractAnnulmentDescription = `${HrPerContractKey.keyPrefix}.contractAnnulmentDescription`;
    public static signedContract = `${HrPerContractKey.keyPrefix}.signedContract`;
    public static internal = `${HrPerContractKey.keyPrefix}.internal`;
    public static trialEndDate = `${HrPerContractKey.keyPrefix}.trialEndDate`;
    public static kindType = `${HrPerContractKey.keyPrefix}.kindType`;
}
